export const Marathi = {
    // ठेकेदार

    "Dashboard": {
        "Titles": {
            "Ward_Name": "प्रभाग क्र.",
            "Work_Assigned_by_Officials": "प्रशासनाने वाटप केलेली कामे ",
            "Garden_Daily_Work": "उद्यान दैनंदिन कामे",
            "Horticulture_Work_Assigned_by_Officials": "उद्यान कामे",
            "Civil_Work_Assigned_By_Officials": "सिव्हिल कामे",
            "Electrical_Work_Assigned_By_Officials": "इलेक्ट्रिकल कामे",
            "Sports_works": "क्रीडा कामे",
            "Work_Progress_By_Contractor": "ठेकेदारनिहाय कामाची प्रगती",
            "Horticulture_Work_Progress_By_Contractor": "उद्यान कामाची प्रगती",
            "Civil_Work_Progress_By_Contractor": "सिव्हिल कामाची प्रगती",
            "Electrical_Work_Progress_By_Contractor": "इलेक्ट्रिकल कामाची प्रगती",
            "Sports_works_Progress": "क्रीडा कामाची प्रगती",
            "Assigned_work": "वाटप कामे",
            "Pending": "प्रलंबित कामे",
            "Completed": "पूर्ण झालेली कामे",
            "Work_Reopen_Progress_By_Contractor": "ठेकेदारनिहाय पुन्हा वाटप केलेल्या कामाची प्रगती",
            "Horticulture_work_reopen_progress": "उद्यान कामाची प्रगती",
            "Reopened_Work": "पुन्हा वाटप केलेली कामे",
            "Civil_Work_Reopen_Progress_By_Contractor": "सिव्हिल कामाची प्रगती",
            "Electrical_Work_Reopen_Progress_By_Contractor": "इलेक्ट्रिकल कामाची प्रगती",
            "Master_Data": "मास्टर डेटा",
            "Sports_works_Reopen_By_Contractor": "क्रीडा कामाची प्रगती",
            "Schedule_Date": "शेड्युलिंग दिनांक",
            "Attendance": "हजेरी",
            "Assigned_Work_Completed": "वाटप कामे केलेली उद्याने",
            "Work_Completed": "पूर्ण कामे केलेली उद्याने",
            "Road_Divider": 'रोड दुभाजक',
        },
        "Pcmc_Assets": {
            "Pcmc_Assets": "PCMC मालमत्ता",
            "Ward_no": "निवडणूक प्रभाग क्र",
            "Sector_Name": "सेक्टरचे नाव",
            "Maintain_By": "देखभाल व दुरुस्ती द्वारा",
            "Sr_No": "अ.क्र",
            "Area_Name": "क्षेत्राचे नाव ",
            "Garden_Name": "उद्यानाचे नाव",
            "Allocation_checklist": "वाटप चेकलिस्ट",
            "Pending_checklist": "प्रलंबित  चेकलिस्ट",
            "Completed_checklist": "पूर्ण केलेली चेकलिस्ट",
            "Image": "फोटो",
            "Track": "ट्रॅक",
            "Action": "कृती",
            "Asset_Type": "मालमत्ता प्रकार",
            "Asset_Name": "मालमत्तेचे नाव",
            "Area": "क्षेत्रफळ (हेक्टरमध्ये)",
            "Area_sq": "क्षेत्रफळ (चौ. मीटरमध्ये)",
            "Status": "स्थिती ",
            "Road_Divider_Name": "रस्ता दुभाजकाचे नाव",
            "Open_Space": "मोकळ्या जागेचे नाव",
            "Tree_Belt_Name": "ट्री बेल्टचे नाव",
            "chowks_Name": "चौकाचे नाव",
            "chowks_master": "चौक",
            "Tree_Belt’s_master": 'ट्री बेल्ट',
            "Play_Equipments": 'क्रीडा साहित्य',
            "Open_Space_master": "मोकळी जागा",
            "Road_Divider": "रस्ता दुभाजक",
            "Garden_Master": "उद्यान",
            // "Zone_Name": "प्रशास्किय प्रभाग",
            "Zone_Name": "झोनचे नाव",
            "Equipment_Name": "उपकरणाचे नाव",
            "Supplier_Name": "ठेकेदाराचे नाव",
            "Area_Square_meter": "क्षेत्रफळ (मीटरमध्ये)"
        },
        "Work_Assigned_by_Officials": {
            "From_Date": "दिनांक पासून",
            "To_Date": "दिनांक पर्यंत",
            "Contractor_Name": "ठेकेदाराचे नाव",
            "Assign_Date": "वाटप केलेल्या कामाची दिनांक",
            "Area1": "क्षेत्राचे नाव",
            "Work_Name": "कामाचे नाव",
            "Assign_Work_Photo": "वाटप कामाचा फोटो",
            "Officer_Name": "अधिकाऱ्याचे नाव",
            "Assign_Contractor_Name": "ठेकेदाराचे नाव",
            "Assigned_By": "प्रशासनाचे नाव",
            "Completed_Work_Date": "पूर्ण झालेल्या कामाचे दिनांक",
            "Completed_Work_Photo": "पूर्ण झालेल्या कामाचा फोटो",
            "BenchMark": "बेंचमार्क",
            "Reopened_By": "प्रशासनाचे नाव",
            "Reopened_Photo": "पुन्हा टाकलेल्या कामाचा फोटो",
            "Work_Date": "पूर्ण केलेल्या कामाची दिनांक"
        }
    },
    "Sidebar": {
        "Dashboard": "डॅशबोर्ड",
        "Preventive_Work_Report": "प्रतिबंधात्मक कार्य अहवाल",
        "Completed_Work_Report": "पूर्ण झालेल्या कामाचा अहवाल",
        "Garden_Report": "उद्यान अहवाल",
        "Employee_Tracking": "कर्मचारी ट्रॅकिंग",
        "Work_Type": "कामाचे प्रकार",
        "Upload_Date": "दिनांक अपलोड करा",
        "Work_Assign_By": "कार्य द्वारे नियुक्ती करा",
        "Work_Done_Date": "काम झाल्याची दिनांक ",
        "Before_Work_Photo": "कामाच्या आधीचा फोटो",
        "After_Work_Photo": "पूर्ण कामाचा फोटो",
        "Role": "रोल",
        "Daily_Work_Sheet": 'दैनंदिन कामाचे तपशील',

    },


    "AdminDashboard": {
        "Admin_Titles": {
            "Daily_Preventive_Work": "दैनिक प्रतिबंधात्मक कार्य",
            "Work_Progress_by_Contractors": "ठेकेदारांकडून कामाची प्रगती",
            "Reopen_Work_Progress": "कामाची प्रगती पुन्हा उघडा",
            "Deputy_Municipal_Commissioner_(DMC)": "उपमहापालिका आयुक्त (DMC)",
            "Garden_Officer_(GO / AGO)": "उद्यान अधिकारी (GO / AGO)",
            "Garden_Assistant_(GA)": "उद्यान सहाय्यक (GA)",
            "Garden_Supervisor_(GS)": "उद्यान पर्यवेक्षक (GS)",
            "Reopen_Pending": "प्रलंबित पुन्हा उघडा",
            "Reopen_Completed": "पूर्ण झालेले कार्य पुन्हा उघडा",



            "Total_Work": 'एकूण कामे',
            'Total_works_Completed': 'पूर्ण केलेल्या कामे',
            "Pending_Work": 'प्रलंबित कामे',
            'Daily_Work_Completed': 'दैनंदिन पूर्ण केलेली कामे',
            'Daily_Work_Pending': 'दैनंदिन प्रलंबित कामे',
            'Remark': 'शेरा'
        },

        "Grid_Heading": {
            "Daily_Preventive_Work_Pending": "प्रलंबित दैनिक प्रतिबंधात्मक काम",
            "Daily_Preventive_Work_Completed": "पूर्ण झालेले दैनिक प्रतिबंधात्मक कार्य ",
            "WORK_ASSIGNED": "नियुक्त केलेले काम",
            "WORK_ASSIGNED_Deputy_Municipal_Commissioner_(DMC)": "नियुक्त केलेले काम / उपमहापालिका आयुक्त (DMC)",
            "WORK_ASSIGNED_Garden_Officer_(GO / AGO)": "नियुक्त केलेले काम / उद्यान अधिकारी (GO / AGO)",
            "WORK_ASSIGNED_Garden_Assistant_(GA)": "नियुक्त केलेले काम / उद्यान सहाय्यक (GA)",
            "WORK_ASSIGNED_Garden_Supervisor_(GS)": "नियुक्त केलेले काम / उद्यान पर्यवेक्षक (GS)",
            "Reopen_Work_Progress_Reopen_Pending": "प्रलंबित कामाची प्रगती पुन्हा उघडा",
            "Reopen_Work_Progress_Reopen_Completed": "पुन्हा उघडलेले कामाची प्रगती",
        },

        "Table_Heading": {
            "Date": "दिनांक",
            "Day": "दिवस",
            "Work_Sub_Type": "कामाचे उप प्रकार",
            "Reopen_Date": "पुन्हा उघडण्याची तारीख",
            "Reopen_Work_Photo": "कामाचा फोटो पुन्हा उघडा",
            "Work_Reopen_Date": "कार्य पुन्हा उघडण्याची तारीख",
            "Reopen_Completed_Work_Date": "पूर्ण झालेल्या कामाची तारीख",
            "Reopen_Completed_Work_Photo": "पूर्ण झालेल्या कामाचा फोटो पुन्हा उघडा",
        },

        "Admin_Sidebar_Name": {
            "Master": "मास्टर",
            "Garden_Reports": "गार्डन अहवाल",
            "Designation": "पदनाम",
            "Employee": "अधिकारी/कर्मचारी माहिती",
            "User_Creation": "यूजर तयार करणे",
            "Ward_Master": "निवडणूक प्रभाग मास्टर",
            "Sector_Master": "सेक्टर मास्टर",
            "Work": "उद्यान कामे ",
            "Project_Name": "प्रकल्पाचे नाव",
            "Work_Sub_Type": "कामाचे उप प्रकार",
            "Contractor_Wise_Assets": "ठेकेदार नुसार उद्यान",
            "Project_Wise_Contractor": "प्रकल्प नुसार ठेकेदार ",
            // "Project_Wise_Work_Name": "प्रकल्पानुसार कामाचे नाव",
            "Garden_wise_maintenance_status": "उद्यान निहाय देखभालीची स्थिती",
            "User_Wise_Ward_Mapping": "यूजर नुसार मॅपिंग"
        },

        "Admin_Sidebar_Grid_Heading": {
            "Designation_Master": "पदनाम मास्टर",
            "Employee_Master": "कर्मचारी मास्टर",
            "User_Creation_Master": "वापरकर्ता निर्माण मास्टर",
            "Contractor_Name_Master": "ठेकेदाराचे नाव मास्टर",
            "Zone_Master": "प्रशासकीय प्रभाग",
            "Sector_Garden_Master": "सेक्टर गार्डन मास्टर",
            "Work_Type_Garden_Master": "उद्यान कामाचा प्रकार मास्टर",
            "Work_Sub_Type_Garden_Master": "उद्यान कामाचे उप प्रकार मास्टर",
            "Work_Garden_Master": "उद्यानाचे काम मास्टर",
            "Project_Name_Master": "प्रकल्पाचे नाव मास्टर",
            "Project_Wise_Contractor_Master": "प्रकल्पनिहाय ठेकेदार मास्टर",
            "Project_Wise_Work_Name_Master": "प्रकल्पानुसार कामाचे नाव मास्टर",
        },

        "Admin_Sidebar_Table_Heading": {
            "Designation_Name": "पदनाम",
            "Mobile_Number": "मोबाइल क्रमांक",
            "Email_Id": "ई-मेल आयडी",
            "Table_User_Name": "सारणी वापरकर्ताचे नाव",
            "User_Name": "वापरकर्ताचे नाव",
            "Password": "पासवर्ड",
            "Address": "पत्ता",
            "Contact_Person_Name": "संपर्क व्यक्तीचे नाव",
            "Zone_Name": "झोनचे नाव",
            "Prabhag_No": "प्रभाग क्र",
            "Benchmark_in_Days": "दिवसांमध्ये",
            "Penalty_Amount_(Rs.)": "दंडाची रक्कम (रु.)",
            "Project_Type": "प्रकल्पाचा प्रकार",
            "User": "वापरकर्ता",
            "Equipment_No.": "उपकरणे क्र.",
            "Equipment_Installation_Date": 'उपकरणे स्थापनेची तारीख',
            "Visited_Date": 'भेट दिलेली तारीख',
            "Work_Description": 'कामाचे वर्णन',
            "Department": 'विभाग',
            "Photo": 'फोटो',
            "Work_Photo": "कामाचा फोटो",
            "After_Work_Photo": 'कामानंतरचा फोटो',
            "Before_Work_Photo": 'कामाच्या आधीचा फोटो ',
            "Total_Gardens": "एकूण उद्यान"
        },
    },
    "EmployeeAndContractor": {
        "Officer_Name_Pending_Work_Status": "कर्मचारीनिहाय ठेकेदारांच्या प्रलंबित कामाचा गोषवारा",
        "Contractor_Name_Pending_Work_Status": "ठेकेदाऱ्यांचा प्रलंबित कामाचा गोषवारा",
        "Total_Assign_Works": "एकूण वाटप केलेल्या कामे",
        "Total_works_Completed": "एकूण पूर्ण केलेल्या कामे",
        "Total_Pending_Works": "एकूण प्रलंबित कामे",
        "Total": 'एकूण',
        "0_to_7_days": "0 ते 7 दिवस",
        "7_to_15_days": "7 ते 15 दिवस",
        "15_to_30_days": "15 ते 30 दिवस",
        "30_to_90_days": "30 ते 90 दिवस",
        "90_to_180_days": "90 ते 180 दिवस",
        "1_year": "1 वर्षा पुढील",
        "Karmachari": 'कर्मचारी',
        'Thekedar': 'ठेकेदार',
        'Karmachariche_Nav': 'कर्माचाऱ्याचे नांव',
        'Thekedaryache_Nav': 'ठेकेदाऱ्यांचे नांव',
        'Daily_Work': 'दैनिक प्रतिबंधात्मक कामे',
        'Yes': 'होय',
        'No': 'नाही',
        'Count': 'संख्या',
        'ChecklistPhoto': 'चेकलिस्ट फोटो',
        'Checklist': 'चेकलिस्ट',
        'ChecklistName': 'चेकलिस्ट नाव',
        'VisitTarget': 'एकूण टार्गेट',
        'Achievement': 'पूर्ण',
        'Pending': 'प्रलंबित'


    },

    // ----------Education Translation ---------

    "Educationdashboard": {
        "dashboard": {
            "Primary_school": "प्राथमिक शाळा",
            "Secondary_school": "माध्यमिक शाळा",
            "Daily_Work": "दैनंदिन कामे",

        }
    },

    // ----------Education Translation ---------

    "Healthdashboard": {
        "dashboard": {
            "Daily_Work": "दैनंदिन कामे",
            "Manpa_school": "मनपा शाळा",
            "Mukhya_Karyalay": "मुख्य कार्यालय",
            "Kshetriy_Karyalay": "क्षेत्रीय कार्यालय",
            "Sarvjanik_Swachhatagruhe": "सार्वजनिक स्वच्छतागृहे",
            "Smashan_Bhumi": "स्मशानभूमी",


        }
    },
    "EncroachmentDashboard": {
        Year: "वर्ष",
        Month: 'महिने',
        Zone: "झोन",
        Dashboard: 'डॅशबोर्ड',
        EncroachmentIllegalConstruction: 'Encroachment & Illegal Construction',
        // अपलोड तक्रारी सोशल मीडिया / अधिकारी विजिट
        UploadComplaintsSocialmediaandOfficerVisit: 'स्वतःला प्राप्त झालेल्या तक्रारी',
        ComplaintStatusfromofficials: 'अधिकाऱ्यांकडून आलेल्या तक्रारीची स्थिती',


        // Dashboard start
        Encromchment: 'अतिक्रमण',
        IllegalConstrcation: 'अनधिकृत बांधकाम',
        EncroachmentIllegalConstruction: 'Encroachment & Illegal Construction',
        Uploadcomplaint: 'अपलोड केलेल्या तक्रारी',
        UploadComplaintDate: 'तक्रार अपलोड दिनांक',
        UploadDate: "अपलोड दिनांक",
        ZoneName: 'झोन',
        VehicleStartPlace: 'पिंजरागाडी सुरु झालेले ठिकाण',
        UploadComplaintPhoto: 'अपलोड तक्रार फोटो',
        FromDate: 'दिनांक पासून',
        ToDate: 'दिनांक पर्यंत',
        View: 'पहा',
        SelfAssigned: 'सेल्फ-Assigned',
        ForwardComplaints: 'फॉरवर्ड केलेल्या तक्रारी',
        ReceivedComplaint: 'प्राप्त तक्रारी',
        AcknowledgedComplaint: 'स्वीकार केलेल्या तक्रारी',
        ForwardComplaint: 'फॉरवर्ड केलेल्या तक्रारी',
        ScheduleComplaint: 'शेड्यूल केलेल्या तक्रारी',
        ClosedComplaint: `पूर्ण झालेल्या तक्रारी`,
        PendingComplaint: 'प्रलंबित तक्रारी',
        TodaysTotalComplate: 'आजच्या तक्रारी',
        TodaysClosedComplaint: 'आजच्या पूर्ण तक्रारी',
        CreateScheduling: 'शेड्युलिंग तयार करा',
        TotalScheduling: 'एकूण शेड्युलिंग',
        UpcomingScheduling: 'आगामी शेड्युलिंग',
        PastScheduling: 'पूर्ण झालेले काम ',
        ComplaintReceivedDate: 'तक्रार मिळालेली दिनांक',
        ComplaintUploadDate: 'तक्रार अपलोड दिनांक',
        UploadPhoto: 'अपलोड फोटो',
        ForwardedComplaints: 'तक्रार फॉरवर्ड करणे',
        complaintsentofficername: 'तक्रार कोणाला पाठवली',
        Forward: 'फॉरवर्ड ',
        Remark: 'शेरा',
        complaintUploadedOfficername: 'तक्रार कोणी अपलोड केली',
        Acknowledge: 'प्राप्त तक्रारी स्वीकार करणे ',
        AcknowledgedDate: 'तक्रार मान्य केलेली दिनांक',
        Forwarddate: 'तक्रार पुढे पाठवलेली दिनांक',
        complaintReceivedOfficerName: 'तक्रार कोणाकडून प्राप्त झाली',
        ComplaintScheduleDate: 'तक्रार शेड्युल दिनांक',
        ComplaintCloseDate: 'तक्रार पूर्ण झालेली दिनांक',
        CompletedPhoto: 'पूर्ण झालेला फोटो',
        Track: 'ट्रॅक',
        OfficerName: 'अधिकाऱ्याचे नाव ',
        date: 'दिनांक',
        Intime: 'इन टाइम',
        OutTime: 'आऊट टाइम',
        TotalHrs: 'एकूण तास',
        ShiftTime: 'सत्र',
        INPhoto: "इन फोटो",
        OutPhoto: "आऊट फोटो",
        PresentEmployee: 'हजर अधिकारी/कर्मचारी',
        AbsentEmployee: 'गैरहजर अधिकारी/कर्मचारी',
        // Reportscheduleddate: 'शेड्युलिंग रीपोर्ट दिनांक',
        ScheduledCreateDate: 'शेड्युलिंग तयार दिनांक ',
        ScheduleDate: 'शेड्युलिंग दिनांक',
        Pathakname: 'पथक नाव',
        Shift: 'सत्र',
        WorkTime: 'कामकाजाची वेळ',
        workArea: 'कामकाजाचे ठिकाण',
        ScheduleReportPdf: 'Schedule Report(Pdf)',
        Open: 'पहा',
        Ward: 'प्रभाग',
        Day: 'दिवस ',
        GroupAttendancetime: 'ग्रुप उपस्थिती टाइम ',
        Photo: 'फोटो',
        Present: 'हजर ',
        Absent: 'गैरहजर',
        EncroachmentandIllegalConstructionWebandMobileBased: 'बांधकाम परवानगी व अनधिकृत बांधकाम नियंत्रण विभाग',
        SurveyNo: 'सर्व्हे नं',
        SarthiPortal: 'सारथी पोर्टल',
        SocialMedia: 'सोशल मीडिया',
        OfficerVisit: "अधिकारी व्हिजिट ",
        CompletedDate: "पूर्ण तारीख",
        CompletedDay: "पूर्ण दिवस",
        EncroachmentWard: "अतिक्रमण प्रभाग ",
        EncroachmentArea: "अतिक्रमण क्षेत्र",
        UploadedThrough: "द्वारे अपलोड केले ",
        FromOfficerName: "तक्रार  कोणाकडून आली",
        FromStatus: "स्थिती",
        ToOfficerName: "तक्रार  कोणास पाठवली",
        ToStatus: "स्थिती",
        CreateByOfficerName: "तक्रार अपलोड केलेल्या अधिकाऱ्याचे नाव",
        NameofForwardedOfficer: "फॉरवर्ड केलेल्या अधिकाऱ्याचे नाव",


        // master
        DepartmentMaster: 'विभाग मास्टर',
        DepartmentName: 'विभागाचे नाव',
        SrNo: 'अ. क्रं.',
        Action: 'कृती',
        Master: 'मास्टर',
        DepartmentMaster: 'विभाग मास्टर',
        RoleMaster: 'रोल मास्टर',
        DesignationMaster: 'पदनाम मास्टर',
        DesignationName: 'पदनाम',
        EmployeeMaster: 'कर्मचारी माहिती',
        UserCreation: 'यूजर तयार करणे',
        ZoneMaster: 'प्रशासकीय प्रभाग (झोन)',
        WardMaster: 'निवडणूक प्रभाग मास्टर',
        ItemMaster: 'वस्तू मास्टर',
        // ItemMaster: 'आयटम मास्टर',
        WorkTypeMaster: 'कामाचे प्रकार',
        // WorkMaster: 'काम मास्टर',
        WorkMaster: 'कामे',
        VehicleMaster: 'वाहन मास्टर ',
        ZoneWiseVehicleMapping: 'झोन निहाय वाहने ',
        ZoneWiseAreaMaster: 'झोन निहाय एरिया मास्टर',
        ZoneWiseArea: 'झोन निहाय एरिया',
        PathakMaster: 'पथक मास्टर',
        // PathakWiseEmployee: 'झोन निहाय कर्मचारी',
        PathakWiseEmployee: 'पथक निहाय कर्मचारी',
        ZoneName: 'झोन',
        EmployeeName: 'अधिकारी/कर्मचारी नाव',
        Actions: ' कृती',
        // AreaName: 'एरिया नाव',
        AreaName: 'कामकाजाचे ठिकाण',
        EmailID: ' ई - मेल',
        Gender: ' लिंग',
        ItemName: 'वस्तूचे नाव',
        JoiningDate: 'नियुक्ती दिनांक',
        MobileNumber: 'मोबाईल क्रमांक ',
        Password: ' पासवर्ड',
        Username: ' यूजरनेम',
        Role: ' रोल',
        PathakName: 'पथक नाव/कोड',
        Status: 'वापरकर्ता स्तिथी',
        VehicleModule: 'वाहनांचे मॉडेल',
        VehicleName: 'वाहनाचे नाव',
        VehicleNumber: 'वाहन क्रमांक',
        WardName: 'प्रभाग',
        WorkName: 'कामाचे नाव',
        WorkTypeName: 'कामाचे प्रकार',
        Status: ' स्थिती',
        Select: 'निवडा',
        Area: 'कामकाजाचे ठिकाण',
        ScheduleDetails: 'शेड्युल तपशील',
        ScheduleDay: 'शेड्युलिंग दिवस',
        pathakNocode: 'पथक नं / कोड',
        WorkTimefrom: 'कामाची चालू वेळ',
        workTimeTo: 'कामाची बंद वेळ',
        // GroupAttendance: 'गट उपस्थिती',
        JoiningDate: 'सेवेत रुजू दिनांक',
        Total: 'एकूण',
        ZoneA: 'झोन-अ',
        ZoneB: 'झोन-ब',
        ZoneC: 'झोन-क',
        ZoneD: 'झोन-ड',
        ZoneE: 'झोन-इ',
        ZoneF: 'झोन-फ',
        ZoneG: 'झोन-ग',
        ZoneH: 'झोन-ह',
        OrderDate: 'आदेश दिनांक',
        OrderDay: 'आदेश दिवस',
        OrderNumber: 'आदेश क्रमांक',
        ScheduleDate: 'शेड्यूल दिनांक',
        ScheduleDay: 'शेड्यूल दिवस',
        ShiftTiming: 'सत्र वेळ',
        ScheduleOrder: 'शेड्यूल ऑर्डर',
        ActionReport: 'कृती अहवाल',
        OrderNumber: 'आदेश क्रमांक',
        Schedule: 'शेड्यूल',
        UserWiseMapping: 'यूजर नुसार मॅपिंग',
        EmployeeCount: "कर्मचारी संख्या",


        // Illegal Constrcation

        // SiteVisits: 'साइट ला भेट दिलेल्या तक्रारी',
        SiteVisits: 'भेट दिलेल्या तक्रारी',
        SiteVerification: 'साइट पडताळणी झालेल्या तक्रारी',
        IssueNotice: 'नोटीस जारी केलेल्या तक्रारी',
        UploadedComplaint: 'अपलोड केलेल्या तक्रारी',
        SiteVisitDate: 'साइट भेट दिनांक',
        SiteVisitPhoto: 'साइट भेट फोटो',
        SiteVisitVideo: 'साइट भेट विडियो',
        SiteVerificationDate: 'दिनांक',
        UploadedBy: 'तक्रार कोणाकडून प्राप्त झाली',
        SiteVerificationPhoto: 'साइट ',
        CompletedPhoto: 'पूर्ण झालेला फोटो',
        ComplaintuploadPhoto: 'तक्रार अपलोड फोटो',
        Notice: 'सूचना',
        ComplaintForwardDate: 'तक्रार पुढे पाठवलेली दिनांक',
        SiteVisitDetails: 'साइट भेट तपशील',
        ComplaintPhoto: 'तक्रार अपलोड फोटो',
        Doyouwanttoclosethecomplaint: 'तुम्हाला तक्रार बंद करायची आहे का?',
        GroupAttendancetime: 'ग्रुप उपस्थिती टाइम ',
        Selfattendance: 'स्व-उपस्थिती',
        EmployeeAttendance: 'कर्मचारी उपस्थिती',
        DailyComplaint: 'रोजच्या तक्रारी ',
        ViewScheduling: 'शेड्युलिंग पहा',
        AddComplainttoScheduling: 'शेड्युलिंगमध्ये तक्रार जोडा',
        ViewVehicleScheduling: 'वाहनाचे शेड्युलिंग पहा',
        TodaysScheduling: 'आजचे शेड्युलिंग',
        TodaysAction: 'आजचे पूर्ण शेड्युलिंग',
        PendingScheduling: 'प्रलंबित शेड्युलिंग',
        FirstShift: 'सकाळ  सत्र',
        SeconsShift: 'दुपार सत्र',
        VehicleTracking: 'पिंजरागाडी ट्रॅकिंग',
        SiteVisit: 'साइट भेट',
        UnrelatedComplaints: 'संबधित नसलेल्या तक्रारी',
        // PendingSiteVisits:'साइट ला भेट न केलेल्या तक्रारी',
        PendingSiteVisits: 'भेट न केलेल्या तक्रारी',
        PendingSiteVerification: 'प्रलंबित साइट पडताळणी',
        DemollitionComplaint: 'बेकायदेशिर काम',
        GroupAttendance: 'ग्रुप उपस्थिती',
        PastScheduling: 'मागील शेड्युलिंग',
        BeforeWorkPhoto: 'कामाच्या आधीचा फोटो',
        AfterWorkPhoto: 'कामाच्या नंतर चा फोटो',
        BeforePhoto: 'आधीचा फोटो',
        AfterPhoto: 'नंतर चा फोटो',
        ComplaintTrack: 'तक्रार ट्रॅक',
        ComplaintActionReport: 'तक्रार अहवाल',
        CompletedScheduling: 'पूर्ण झालेले शेड्युलिंग',
        Report: 'अहवाल',
        ReceivedComplaints: 'प्राप्त तक्रारी',
        // NoticeIssue:'नोटीस इश्यू',
        NoticeIssue: 'नोटीस जारी केलेल्या तक्रारी',
        SiteVerification: 'साइट पडताळणी',
        PendingSiteVerification: 'साइट पडताळणी न केलेल्या तक्रारी',
        SingedNotice: 'Singed Notice',
        ActionTaken: 'कारवाई केलेल्या तक्रारी',
        Approvedby: 'Approved by',
        ConstructionType: 'बांधकाम प्रकार',
        SiteVerificationOfficerName: 'साइट सत्यापन अधिकारी नाव',
        OwnerDetails: 'मालकाचे तपशील',
        Village: 'गाव',
        location: 'ठिकाण',
        TotalArea: 'एकूण क्षेत्रफळ',
        ShowNotice: 'नोटीस',
        ConstructionBoundaries: 'बांधकामाची चर्तु:सीमा',
        ConstructionBoundariesName: 'बांधकाम सीमांचे नाव',
        Video: 'व्हिडिओ',
        East: 'पूर्व',
        West: 'पश्चिम',
        South: 'दक्षिण',
        North: 'उत्तर',
        Verifiednotices: 'पडताळणी केलेल्या नोटिस',
        legalSite: 'अधिकृत साइट',
        CourtCases: 'न्यायालयीन प्रकरणे',
        SiteVisitComplaintsReceived: 'साइटला भेट देण्याच्या प्राप्त तक्रारी',
        SiteVisitedComplaints: 'भेट दिलेल्या तक्रारी',
        NoticeIssueComplaints: 'नोटीस जारी केलेल्या तक्रारी',
        ViewSignedNotice: 'View Signed Notice',
        SiteVerificationDetails: 'साइट पडताळणी तपशील',
        ConstructionBoundariesDetails: 'बांधकाम सीमा तपशील',
        UploadComplaintDetails: 'तक्रारीचे तपशील',
        IssueNoticeDate: 'नोटीस जारी केल्याची दिनांक',
        SiteOfficerVerificationName: 'पडताळणी अधिकाऱ्याचे नाव',
        Clause: 'कलम',
        Notice: 'नोटीस',
        NoticeNo: 'नोटीस नंबर',
        SiteVerificationReamrk: 'साइट पडताळणी शेरा',
        CourtNotice: 'न्यायालयीन नोटीस',
        Nameoftheofficerissuingthenotice: 'नोटीस जारी केलेल्या अधिकाऱ्याचे नाव',
        NoticePeriod: 'नोटीस कालावधी',
        NoticeVerified: 'नोटीस बजावलेला फोटो',
        ServeNotice: 'नोटीस बजावणी',
        Return: ' रिटर्न',
        SizedItemDetails: 'जप्त केलेल्या वस्तूंचे तपशील',
        SeizedItemList: 'जप्त केलेल्या वस्तूंची यादी',
        OwnerDetails: 'मालकाचे नाव व माहिती',
        ItemList: 'वस्तूंची यादी',
        Count: 'संख्या',
        Doyouwanttoreturnthecomplaint: 'तुम्हाला तक्रार परत पाठवायची आहे का ?',
        Select: "निवडा...",
        Team: "संघ",
        Pathak: 'पथक'
    }
}